import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import { AllReportLayerList } from '../components/Report/AllReportLayerList'

export const AllReportPageList = () => {
  return (
    <MasterLayout>
        <AllReportLayerList/>
    </MasterLayout>
  )
}
